import { LocalizationFile } from '../data/localization-file';

export abstract class LocalizationLoader {
  abstract load(locale: string, module?: string): Promise<LocalizationFile>;
}
